'use strict';
import FluxConstant from 'flux-constant';


export default FluxConstant.set([
    'SEND_MESSAGE',
    'SEND_MESSAGE_RESPONSE',
    'RESET'
]);
